import React, { useState } from "react";
import { Columns3, Plus } from "lucide-react";

export const DENS = { "ÇOK DAR": [18, 10], DAR: [22, 11], ORTA: [28, 12], BÜYÜK: [36, 14] };

export function useListPrefs(id, defHidden = []) {
  const read = (k, d) => { try { return JSON.parse(localStorage.getItem(`mw_lp_${id}_${k}`)) ?? d; } catch { return d; } };
  const [size, setSizeS] = useState(() => read("size", "DAR"));
  const [hidden, setHiddenS] = useState(() => read("hidden", defHidden));
  const [custom, setCustomS] = useState(() => read("custom", []));
  const save = (k, setter) => (v) => { setter(v); localStorage.setItem(`mw_lp_${id}_${k}`, JSON.stringify(v)); };
  const [h, f] = DENS[size] || DENS.DAR;
  return { size, setSize: save("size", setSizeS), hidden, setHidden: save("hidden", setHiddenS), custom, setCustom: save("custom", setCustomS),
    tableProps: { className: "mw-dens", style: { "--mw-row": `${h}px`, fontSize: f } } };
}

export const ListTools = ({ id, prefs, cols, canAdd = true }) => {
  const [open, setOpen] = useState(false);
  const [name, setName] = useState("");
  const add = () => { const n = name.trim().toLocaleUpperCase("tr-TR"); if (n && !prefs.custom.includes(n)) prefs.setCustom([...prefs.custom, n]); setName(""); };
  return (
    <div className="relative flex flex-wrap items-center gap-1 text-[11px] font-bold text-slate-300">
      <span>SATIR</span>
      {Object.keys(DENS).map((k) => <button key={k} data-testid={`${id}-size-${k}`} onClick={() => prefs.setSize(k)} className={`rounded px-2 py-1 ${prefs.size === k ? "bg-blue-600 text-white" : "bg-slate-800 text-slate-300"}`}>{k}</button>)}
      <button data-testid={`${id}-cols`} onClick={() => setOpen(!open)} className="ml-1 flex items-center gap-1 rounded bg-slate-800 px-2 py-1 text-slate-200"><Columns3 className="h-3.5 w-3.5" /> SÜTUNLAR</button>
      {open && (
        <div data-testid={`${id}-cols-menu`} className="absolute right-0 top-8 z-30 w-64 space-y-1 rounded-lg border border-slate-700 bg-slate-900 p-2 shadow-xl">
          {[...cols, ...prefs.custom.map((c) => [c, c])].map(([k, l]) => (
            <label key={k} className="flex items-center gap-2 text-xs font-semibold text-slate-200">
              <input type="checkbox" data-testid={`${id}-col-${k}`} checked={!prefs.hidden.includes(k)} onChange={(e) => prefs.setHidden(e.target.checked ? prefs.hidden.filter((x) => x !== k) : [...prefs.hidden, k])} />{l}
              {prefs.custom.includes(k) && <button onClick={() => prefs.setCustom(prefs.custom.filter((x) => x !== k))} className="ml-auto text-rose-500">×</button>}
            </label>
          ))}
          {canAdd && <div className="flex gap-1 border-t border-slate-800 pt-1"><input data-testid={`${id}-col-new`} value={name} onChange={(e) => setName(e.target.value)} onKeyDown={(e) => e.key === "Enter" && add()} placeholder="YENİ BAŞLIK" className="h-7 flex-1 rounded border border-slate-700 bg-slate-800 px-1 text-xs" />
            <button data-testid={`${id}-col-add`} onClick={add} className="rounded bg-blue-600 px-2 text-white"><Plus className="h-3.5 w-3.5" /></button></div>}
        </div>
      )}
    </div>
  );
};
